/**
 * ISO 3166-1 alpha-2 country codes for the Americas.
 * Used for automatic regional routing (EU/US) when no account affinity exists.
 */
export var AMERICAS_COUNTRY_CODES = [
    'US',
    'CA',
    'MX',
    'BR',
    'AR',
    'CL',
    'CO',
    'PE',
    'VE',
    'UY',
    'PY',
    'EC',
    'BO',
    'GY',
    'SR',
    'GF',
    'PA',
    'CR',
    'NI',
    'HN',
    'SV',
    'GT',
    'BZ',
];
